<template>
	<div
		v-if="moduleVisibility"
		class="webmd-bottom-recommended-module" :class="{'conmkt':isContMktTab}"
	>
		<div class="module-title">
			Recommended
		</div>
		<div
			class="recommended-bottom-module"
			v-metric="{module: relMmodule}"
			:class="{'no-image': !moduleImage}"
		>
			<div class="recommended-module-image" v-if="moduleImage && moduleImage.src">
				<img :src="moduleImage.src" :alt="moduleImage.alt" />
			</div>
			<div class="recommended-module-posts">
				<div
					class="recommended-module-link"
					v-for="(item, index) in items"
					:key="item.title"
				>
					<div
						v-if="item.sponserText == true"
						class="sponser-text"
					>
						Sponsored
					</div>
					<a
						v-metric="{link: index + 1}"
						:href="item.href"
					>
						{{ item.text }}
					</a>
					<div
						v-if="item.labelText"
						class="bottom-recommended-module-teaser"
					>
						{{ item.labelText }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ModuleLinks from 'webmd-dynamic-links/index.es6';
import useStore from '@/useStore.js';
import { get, sample } from 'lodash';
export default {
	data() {
		return {
			items: [],
			subTitle: 'Related',
			moduleVisibility: true,
			imageArray: [],
			moduleImage: '',
			imageList: [],
			imgServerUrl: null,
			ecdQuery: '',
			isContMktTab: false,
		};
	},
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		relMmodule: {
			type: String,
			default() {
				return 'rcmmnd';
			},
		},
		relMlink: {
			type: String,
			default() {
				return '';
			},
		},
	},
	computed: {
		getModuleByChronicId() {
			const module = this.store.cms.getModules(this.chronicId);
			return module;
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.moduleData = this.getModuleByChronicId;
		this.imageList = get(this.moduleData, 'module_data.body_images.body_image', []);

		if (this.moduleData && this.imageList) {
			this.imgServerUrl = get(this.store, 'pagedata.omniture.image_server_url', 'https://img.wbmdstatic.com/vim/live');

			this.moduleImage = this.getModuleImage(this.imageList);
		}

		this.ecdQuery = this.$route?.query?.ecd || '';
	},
	mounted() {
		this.isContMktTab = (document.body.clientWidth > 767 && document.body.clientWidth < 1025) && (this.ecdQuery.includes('conmkt'));
		this.$nextTick(() => {
			// to lazy load
			const dlOptions = {
				module: 20,
				count: 4,
			};

			const self = this;
			const observer = new IntersectionObserver((entries) => {
					if (entries[0].isIntersecting) {
						ModuleLinks.fill(dlOptions).then((links) => {
							if (links) {
								self.items = self.parseDynamicData(links);
								observer.unobserve(self.$el);
								if (self.items.length === 0) {
									self.moduleVisibility = false;
								}
							}
						});
					}
				},
				{ rootMargin: '0px 0px 800px 0px' });

			observer.observe(self.$el);

			// to refresh in the future outside of module
			document.addEventListener('webmd.wdl.refresh', async (event) => {
				if (!event.detail || event.detail === 20) {
					const links = await ModuleLinks.fill(dlOptions);
					if (links) {
						self.items = self.parseDynamicData(links);
						if (self.items.length === 0) {
							self.moduleVisibility = false;
						}
					}
				}
			});
		});
	},
	methods: {
		parseDynamicData(links) {
			return links.map((l) => ({
				text: l.title,
				href: l.url,
				labelText: l.teaser,
				sponserText: l.sponsored,
			}));
		},

		getModuleImage(imageList) {
			let imageArray = imageList.map(i => {
				return {
					src: i.source.path ? `${this.imgServerUrl}${i.source.path}?resize=500px:*&output-quality=75` : null,
					alt: i.source.alt
				}
			}).filter(i => i.src);

			if(imageArray.length > 0) {
				return sample(imageArray)
			}

			return null;
		},

	},

};
</script>

<style lang="scss">
@import "./stylesheets/variables";
@import "./stylesheets/component.scss";
</style>
